export const PERMISSION_GROUPS_QUERY_KEY = ["permission-groups"];
